import * as React from "react";
import { arrayField } from "@common";
import * as cn from "classnames";
import { FieldError } from "../ErrorMessage";
import { RestrictionMapping } from "@store";

export interface RestrictionsComponentProps {
    value: string[] | null;
    field: any | null;
    restrictionsMapping: RestrictionMapping[];
    onChange: { events: any };
    // Other props here
}

export const RestrictionsComponent = ({ restrictionsMapping, value, field, onChange }: RestrictionsComponentProps) => (
    <div className={cn("restrictions-wrapper", field.visualState)}>
        <div className="restrictions-col">
            {restrictionsMapping &&
                restrictionsMapping.map((r, i) => (
                    <label key={i} className="common-checkbox custom-restrictions-checkbox important">
                        <input
                            type="checkbox"
                            name="restrictions"
                            value={r.type}
                            id=""
                            checked={arrayField.toCheckbox.checked(field, r.type)}
                            {...arrayField.toCheckbox.events(field, onChange.events, r.type)}
                        />
                        {r.title}
                        <span className="checkmark" />
                    </label>
                ))}
        </div>
        <div className="restrictions-col">
            <label
                className="common-checkbox custom-brand-safe-checkbox custom-brand-safe-img custom-restrictions-checkbox important"
                id="custom-brand-img"
                style={{ cursor: "initial" }}
            >
                <span className="brand-safe-block" />
                Fraud&nbsp;Protection&nbsp;&nbsp;<img
                    src="../../../assets/images/logo_white.png"
                    alt="AdCtrl Defender"
                />
            </label>
            <label
                className="common-checkbox custom-brand-safe-checkbox custom-restrictions-checkbox important"
                id="custom-brand-label"
                style={{ cursor: "initial" }}
            >
                <span className="brand-safe-block" />*Brand Safe
            </label>
        </div>
        <FieldError field={field} />
    </div>
);
